var _excluded = ["id", "onKeydownDay", "active", "day", "disabled", "week", "onClick", "onMouseEnter", "onMouseLeave"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import StyledCalendarTableDay from './styles/calendar.table-day.styles';
var calendarDayPropTypes = {
  active: PropTypes.bool,
  day: PropTypes.object,
  disabled: PropTypes.bool,
  onKeydownDay: PropTypes.func.isRequired,
  week: PropTypes.number,
  onClick: PropTypes.func.isRequired,
  id: PropTypes.string,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func
};
var calendarDayDefaultProps = {
  active: false,
  day: {},
  disabled: false,
  week: 0,
  id: '',
  onMouseEnter: function onMouseEnter() {},
  onMouseLeave: function onMouseLeave() {}
};
var CalendarDay = function CalendarDay(_ref) {
  var id = _ref.id,
    onKeydownDay = _ref.onKeydownDay,
    active = _ref.active,
    day = _ref.day,
    disabled = _ref.disabled,
    week = _ref.week,
    onClick = _ref.onClick,
    onMouseEnter = _ref.onMouseEnter,
    onMouseLeave = _ref.onMouseLeave,
    other = _objectWithoutProperties(_ref, _excluded);
  var buttonRef = useRef();
  var onDayClick = function onDayClick(event) {
    onClick(day, event);
  };
  var onDayEnter = function onDayEnter() {
    onMouseEnter(day);
  };
  var onDayLeave = function onDayLeave() {
    onMouseLeave(day);
  };
  var onKeydown = function onKeydown(event) {
    onKeydownDay(event, week, day);
  };
  var weekend = day.isWeekend;
  var today = day.isToday;
  return /*#__PURE__*/React.createElement(StyledCalendarTableDay, _extends({}, other, {
    ref: buttonRef,
    id: id,
    type: "button",
    onClick: onDayClick,
    onKeyDown: onKeydown,
    onMouseEnter: onDayEnter,
    onMouseLeave: onDayLeave,
    onFocus: onDayEnter,
    onBlur: onDayLeave,
    disabled: disabled,
    weekend: weekend,
    today: today,
    active: active
  }), day.day);
};
CalendarDay.propTypes = calendarDayPropTypes;
CalendarDay.defaultProps = calendarDayDefaultProps;
export default CalendarDay;